/* GALATEA: hide the "Shipping calculated at checkout" line on variants that
   do not require shipping. Variant-level and live-updating, because switching
   variant does not reload the page.
   Added 2026-08-27. Touches nothing else; delete the file and the theme.liquid
   include to revert completely. */
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;

  var tax = document.querySelector('.product__tax');
  if (!tax) return;

  // routes.root keeps this working under the localized prefixes (/de-eu/, /pl-eu/ ...)
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var handle = window.location.pathname.split('/products/')[1].split('?')[0].split('#')[0];
  var map = null;

  function currentVariantId() {
    var input = document.querySelector('input.product-variant-id');
    if (input && input.value) return String(input.value);
    try {
      return new URLSearchParams(window.location.search).get('variant');
    } catch (e) {
      return null;
    }
  }

  function apply() {
    if (!map) return;
    var id = currentVariantId();
    if (!id) return;
    var requiresShipping = map[String(id)];
    if (requiresShipping === undefined) return;
    tax.style.display = requiresShipping ? '' : 'none';
  }

  fetch(root + 'products/' + handle + '.js')
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.variants) return;
      map = {};
      p.variants.forEach(function (v) {
        map[String(v.id)] = v.requires_shipping !== false;
      });
      apply();
    })
    .catch(function () {});

  var input = document.querySelector('input.product-variant-id');
  if (input && window.MutationObserver) {
    new MutationObserver(apply).observe(input, {
      attributes: true,
      attributeFilter: ['value']
    });
  }
  document.addEventListener('change', function () { setTimeout(apply, 50); });
})();
